import { render, staticRenderFns } from "./SurveyResponse.vue?vue&type=template&id=5b33d123&scoped=true"
import script from "./SurveyResponse.vue?vue&type=script&lang=js"
export * from "./SurveyResponse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b33d123",
  null
  
)

export default component.exports